import React from "react";

// Logo officiel (fichiers de la charte) : « clair » sur fond ivoire/blanc, « sombre » sur fond graphite.
export const BrandLogo = ({ variant = "clair", className = "h-9 w-auto", testid = "brand-logo" }) => (
  <img src={`/brand/360immoinvest-logo-horizontal-${variant}.png`} alt="360immoinvest" className={className} data-testid={testid} />
);
